import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
    createOrEditLeaseApi, 
    approveRejectLeaseApi 
} from "./horseLeasingApi";

export const CreateOrEditHorseLeasethunk = createAsyncThunk(
    "horseLeasing/CreateOrEdit",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await createOrEditLeaseApi(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            );
        }
    }
);

export const ApproveRejectHorseLeasethunk = createAsyncThunk(
    "horseLeasing/ApproveReject",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await approveRejectLeaseApi(payload);
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message
            );
        }
    }
);
